import { render, staticRenderFns } from "./Categoriesplay.vue?vue&type=template&id=678de375"
import script from "./Categoriesplay.vue?vue&type=script&lang=js"
export * from "./Categoriesplay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports